import { motion } from "framer-motion";
import React, { FC } from "react";
import { Link } from "react-router-dom";
import { GrFormNextLink } from "react-icons/gr";

interface CardProps {
  bg: string;
  title: string;
  desc: string;
  path: string;
}

const PageCard: FC<CardProps> = ({ bg, title, desc, path }) => {
  return (
    <Link
      to={path}
      className="relative flex flex-col justify-end p-5 h-[349px] max-w-[379px] w-full rounded-lg overflow-hidden shadow-xl group"
    >
      <div className="hidden absolute top-5 right-5 transform z-10 w-10 h-10 rounded-full bg-primary group-hover:flex items-center justify-center text-white transition-all duration-300 cursor-pointer text-sm">
        <motion.div
          initial={{ scale: 1 }}
          whileHover={{ scale: 1.2 }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
        >
          <GrFormNextLink />
        </motion.div>
      </div>
      <div
        className="absolute inset-0 transition-all duration-300 transform bg-center bg-cover group-hover:scale-105"
        style={{
          backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.75)), url(${bg})`,
        }}
      ></div>

      <div className="absolute inset-0 transition-all duration-300 bg-black/5 group-hover:bg-black/1"></div>

      <div className="relative z-10 text-white flex flex-col items-center">
        <div>
          <h4 className="text-center w-max font-bold">{title}</h4>
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: "75%" }}
            transition={{ duration: 3.5, ease: "easeInOut" }}
            className="w-3/4 mb-2 border-2 rounded-md border-primary"
          />
        </div>

        <p className="text-center text-[14px] font-medium">{desc}</p>
      </div>
    </Link>
  );
};

export default PageCard;
